import { createContext, Dispatch, SetStateAction } from 'react';

export interface LoadingContextProps {
  loading: boolean;
  setLoading: Dispatch<SetStateAction<boolean>>;
}

export const LoadingContext = createContext<LoadingContextProps | undefined>(undefined);
